import React, { ReactElement } from 'react';
import Modal from './Modal';

interface ConfirmationModalProps {
  isOpen: boolean,
  onConfirm: () => void,
  onCancel: () => void,
  confirmButtonText?: string,
  cancelButtonText?: string,
  confirmButtonStyle?: string,
  cancelButtonStyle?: string,
  heading: string,
  children?: React.ReactNode,
  id?: string,
}

const ConfirmationModal = (props: ConfirmationModalProps): ReactElement => {
  const properties = {
    confirmButtonText: 'Yes',
    cancelButtonText: 'Cancel',
    confirmButtonStyle: 'primary',
    cancelButtonStyle: 'grey',
    ...props,
  };

  return <Modal
    isOpen={properties.isOpen}
    heading={properties.heading}
    id={properties.id}
    buttons={[
      { text: properties.cancelButtonText, onClick: properties.onCancel, style: properties.cancelButtonStyle },
      { text: properties.confirmButtonText, onClick: properties.onConfirm, style: properties.confirmButtonStyle },
    ]}
  >
    {properties.children}
  </Modal>;
};

export default ConfirmationModal;
